import { useToggle } from "client/hooks/utils/useToggle";
import { translateFunc } from "client/utils/translateFunc";
import { ColorPickerRainBowIcon } from "components/common/Icons/ColorPickerRainbowIcon";
import { Popup } from "components/common/Popup/Popup";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useFindTextBox } from "../useFindTextBox";
import { Content } from "./Content/Content";

interface ColorProps {
    textBoxId: string;
}

export const Color = ({ textBoxId }: ColorProps) => {
    const { isOpen, onClose: close, toggle } = useToggle();
    const { textBox } = useFindTextBox(textBoxId);
    return (
        <Popup isOpen={isOpen} close={close} content={<Content textBox={textBox} />}>
            <ToolTip text={translateFunc("color-settings")}>
                <button className="border-2 border-irBlue-200 rounded-full p-0.5 focus:outline-4" onClick={toggle}>
                    <ColorPickerRainBowIcon />
                </button>
            </ToolTip>
        </Popup>
    );
};
